import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { prop } from "../../decorators/property";
import { AppSettings } from "../../app-settings";
import { CitationLinksModel } from "../models/citation-links";

@backboneModelProperties({
    defaults: {
        Sources: []
    },
    relations: [{
        key: "Sources",
        relatedModel: CitationLinksModel,
        type: Backbone.Many,
    }],
})
export class SourceLinkCollection extends Backbone.AssociatedModel {

    @prop() public Sources: Backbone.Collection<CitationLinksModel>;
    @prop() public CanUsersChangeSettings: boolean;

    constructor(options?) {
        super(options);
    }

    public fetchAll(references: string[]): Promise<Backbone.Collection<any>> {
        return new Promise<any>((resolve) => {
            if (references && references.length > 0) {
                $.ajax({
                    url: `${AppSettings.ApiUrlPrefix}fulltextsources`,
                    data: { "": references },
                    dataType: "json",
                    type: "POST",
                    beforeSend: AuthorizationModel.attachAuthorizationHeader
                }).then((data) => {
                    this.Sources = data;
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    public fetchSettings(): Promise<Backbone.Collection<any>> {
        return new Promise<any>((resolve) => {
            $.ajax({
                url: `${AppSettings.ApiUrlPrefix}sourcelinksettings`,
                data: {},
                dataType: "json",
                type: "GET",
                beforeSend: AuthorizationModel.attachAuthorizationHeader
            }).then((data) => {
                this.CanUsersChangeSettings = data.CanUsersChangeSettings;
                resolve();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/source-links.ts